import axios from "axios";
import Config from "../config/Config";
import authHeader from "./auth-header";

const API_PUBLIC_URL = Config.BASE_URL_API_PUBLIC;

const functionsCoverageArea = {
	getStatesByCountry(){
		return axios.post(API_PUBLIC_URL + `/coverageAreas/states`, {

		}, {
			headers: authHeader()
		});
	},
	getCitiesByState(stateID: string){
		return axios.post(API_PUBLIC_URL + `/coverageAreas/cities`, {
			stateID: stateID
		}, {
			headers: authHeader()
		});
	},
	getAreaStatesByCountry(){
		return axios.get(API_PUBLIC_URL + `/areas/states`);
	},
	getAreaCitiesByState(stateID: string){
		return axios.get(API_PUBLIC_URL + `/areas/cities/${stateID}`);
	},
	getCoverageAreasByFilter(state: string, city: string){
		return axios.post(API_PUBLIC_URL + `/coverageAreas/filter`, {
			state: state,
			city: city
		}, {
			headers: authHeader()
		});
	},
	updateCoverageArea(state: string, city: string, coverageArea: string, price: number, enabled: boolean){
		return axios.post(API_PUBLIC_URL + `/coverageAreas/update`, {
			state: state,
			city: city,
			coverageArea: coverageArea,
			price: price,
			enabled: enabled
		}, {
			headers: authHeader()
		});
	}
};

export default functionsCoverageArea;